import PropTypes from 'prop-types';
import React from 'react';


/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const NativeImage = ({
    alt = '',
    className = '',
    height,
    psrc,
    px2,
    src,
    style = {},
    width,
    x2,
    // ...restProps
}) => {
    return (
        <picture>
            {/* Webp x2 */}
            <source
                media='(-webkit-min-device-pixel-ratio: 1.5)'
                src={px2}
                type='image/webp' />

            {/* Fallback x2 */}
            <source
                media='(-webkit-min-device-pixel-ratio: 1.5)'
                src={x2} />

            {/* Webp x1 */}
            <source
                src={psrc}
                type='image/webp' />

            {/* Fallback x1 */}
            <img
                alt={alt}
                className={className}
                height={height}
                src={src}
                style={style}
                width={width} />
        </picture>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    alt: PropTypes.string,
    className: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    psrc: PropTypes.string,
    px2: PropTypes.string,
    src: PropTypes.string,
    style: PropTypes.object,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    x2: PropTypes.string

};

NativeImage.propTypes = propTypes;

export default NativeImage;
